export default function Header() {
  return (
    <header className="header">
      <h1 className="header__logo">DrivenEats</h1>
      <span className="header__subtittle">Sua comida em 6 minutos</span>
    </header>
  );
}
